import React from "react";
import { Button, Card, Modal, Col, Form, Input, Row, Switch, Cascader, DatePicker, notification } from "antd";
import { connect } from "react-redux";


import {
  deleteStore
} from "appRedux/actions/StoreCoupons";

import {
  fetchStores
} from "appRedux/actions/Coupons";


class ModalDelete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    }
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };



  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'La tienda se ha eliminado con éxito.',
      });
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al registrar la tienda.',
      });
    }
  };

  onHandleClick = () => {
    this.props.deleteStore(this.props.recording, () => { this.props.fetchStores(); });
    this.onNotification('success');
  }

  onHandleCancel = () => {
    this.props.fetchStores();
    this.setState({ visible: false });
  }

  render() {

    return (
      <div>
        <Button type="danger" onClick={this.showModal}><i className="icon icon-trash" /></Button>
        <Modal
          okText="Borrar"
          cancelText="Salir"
          title="Borrar"
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.onHandleCancel}
        >
          <p>Está seguro de eliminar la tienda {this.props.recording.name}?</p>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps({ placeStores }) {
  return {
    placeStores,
  }
}

export default connect(mapStateToProps, { deleteStore, fetchStores })(ModalDelete);



// WEBPACK FOOTER //
// ./src/routes/main/Store/ModalDelete.js